import React, { useState, useEffect} from 'react';

const EditFornecedorModal = ({ fornecedor, onSave, onCancel }) => {
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    id: '',
    nome: '',
    nomeResponsavel: '',
    telefone: '',
    email: '',
  });

  useEffect(() => {
    if (fornecedor) {
      setFormData(fornecedor);
    }
  }, [fornecedor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSave(formData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-fornecedor-modal">
      <h3>Editar Fornecedor</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>
            Nome do Fornecedor:
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </label>
        </div>
        <div className="form-group">
          <label>
            Nome do Responsável:
            <input
              type="text"
              name="nomeResponsavel"
              value={formData.nomeResponsavel}
              onChange={handleChange}
            />
          </label>
        </div>
        <div className="form-group">
          <label>
            Número de Contato:
            <input
              type="text"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
            />
          </label>
        </div>
        <div className="form-group">
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </label>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={onCancel} className="btn-secundario">Cancelar</button>
          <button type="submit" className="btn-primario" disabled={loading}>Salvar</button>
        </div>
      </form>
    </div>
  );
};

export default EditFornecedorModal;
